import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-pm-wishlist-filter',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule
  ],
  templateUrl: './pm-wishlist-filter.component.html',
  styleUrl: './pm-wishlist-filter.component.scss'
})
export class PmWishlistFilterComponent {

  appliedFilters={
    dikshyarthiName:'',
    address:'',
    isVisited:-1
  }

  constructor(
    public dialogRef:MatDialogRef<PmWishlistFilterComponent>
  ){}
  applyFilter(){
    // console.log(Object.fromEntries(Object.entries(this.appliedFilters).filter((item)=>item[1]!==-1)));item
    let filters=Object.fromEntries(Object.entries(this.appliedFilters).filter(([key,value])=>value!==-1&&value!==''));
    this.dialogRef.close(filters);
  }
}
